// React, store and 3rd party
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import moment from 'moment';

// Components Icons
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';

// Store
import { breadcrumbsActions } from '@store/breadcrumbs';
import { usePermissions } from '@store/auth';
import ApplicationPageTemplate from '@dashboardComponents/ApplicationPageTemplate/ApplicationPageTemplate';
import {
  getCurrencies,
  paymentOptionsCurrenciesActions,
  selectCurrencies,
} from '../../store/payment-options-currencies';

import {
  CURRENCY_NEW_ROUTE,
  // CURRENCY_LIST_ROUTE,
  viewCurrencies,
} from '../../payment-options.breadcrumbs';

import TableToolbar from '../../../../components/TableToolbar';

function CurrencyToolbar({ navigate, permissions }) {
  return (
    <TableToolbar>
      <Button
        disabled={!permissions?.canEditPaymentOptions}
        variant="contained"
        size="large"
        onClick={() => navigate(CURRENCY_NEW_ROUTE)}
        startIcon={<AddIcon />}>
        Add new currency
      </Button>
    </TableToolbar>
  );
}

export default function Currencies() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permissions = usePermissions();

  const [isFetchingData, setIsFetchingData] = useState(true);

  const currencies = useSelector(selectCurrencies);

  useEffect(() => {
    dispatch(breadcrumbsActions.showMenu(true));
    dispatch(breadcrumbsActions.setBreadcrumbs(viewCurrencies));
    dispatch(paymentOptionsCurrenciesActions.resetSelectedCurrency());
  }, [dispatch]);

  useEffect(() => {
    setIsFetchingData(true);
    dispatch(getCurrencies()).then(() => {
      setIsFetchingData(false);
    });
  }, [dispatch]);

  return (
    <ApplicationPageTemplate
      title="Currencies"
      description="List of supported payment currencies. You can also the page to add and update currencies."
      pageReady={!isFetchingData}>
      <DataGrid
        density="standard"
        style={{ background: 'white' }}
        rows={currencies}
        rowsPerPageOptions={[10]}
        pageSize={10}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
        components={{
          Toolbar: () => CurrencyToolbar({ navigate, permissions }),
        }}
        componentsProps={{
          toolbar: {
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
        // @TODO: Uncomment once API is available
        // onRowClick={({ row }) => {
        //   navigate(`${CURRENCY_LIST_ROUTE}/${row.id}`);
        // }}
        getRowId={(row) => row.id}
        columns={[
          {
            field: 'id',
            headerName: 'ID',
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          {
            field: 'code',
            headerName: 'Code',
            flex: 1,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          // {
          //   field: 'modifiedBy',
          //   headerName: 'Modified By',
          //   flex: 1,
          //   sortable: false,
          //   headerAlign: 'center',
          //   align: 'center',
          // },
          // {
          //   field: 'modifiedAt',
          //   headerName: 'Last Modified Date',
          //   flex: 1,
          //   sortable: false,
          //   headerAlign: 'right',
          //   align: 'right',
          //   valueGetter: ({ row }) =>
          //     moment(row.modifiedAt).format('YYYY/MM/DD - HH:mm'),
          // },
        ]}
      />
    </ApplicationPageTemplate>
  );
}
